/**
 * 「房間」只剩這一個清單（#12）。
 *
 * 以前同一份房間資料在三個地方各畫一次：`#/rooms` 整頁面板、收件匣右側抽屜的「房間」分頁、
 * 以及抽屜的「健康」分頁。三份長得一樣、狀態各自漂移。現在收斂成這一個元件：
 *
 * - 桌面：工作台右側抽屜（只有這一欄，沒有分頁）／房間頁的左欄。
 * - 手機：抽屜內容（預設收起，選完房間自動收起，由 `InboxLayout` 管開合）。
 *
 * `RoomPanel` 本身留在 console-ui（資料與樣式都在那），這裡只負責接
 * `ConsoleActions` 的欄位、以及「點一列＝換情境」的語意。
 */
import { RoomPanel } from '@chat-rea/console-ui';
import type { RoomInfo } from '@chat-rea/console-ui';
import type { ConsoleActions } from '../../hooks/useConsoleActions';

export interface RoomSidebarProps {
  c: ConsoleActions;
  /** 點一列時把主區切到這間房；不給就是唯讀列表（例如別的頁面只想顯示）。 */
  onSelect?: (room: RoomInfo) => void;
  /** 目前情境房間（`c.active?.room`）；用來畫選取態。 */
  selectedRoom?: string | null;
  className?: string;
}

export function RoomSidebar({ c, onSelect, selectedRoom = null, className }: RoomSidebarProps) {
  return (
    <div className={className ?? 'inbox-slot'} data-testid="room-sidebar">
      <RoomPanel
        rooms={c.rooms}
        currentRoom={c.currentRoom}
        accounts={c.conversations}
        busy={c.busy}
        onJoin={c.joinRoom}
        onRefresh={() => void c.loadRooms(c.currentService)}
        error={c.roomsError}
        loading={c.roomsLoading}
        onSelect={onSelect}
        selectedRoom={selectedRoom}
      />
    </div>
  );
}
